var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.firstLoad)?_c('div',{staticClass:"button-scroll-top is-clickable",class:{
    'show-button-animation': _vm.showButtonAnimation,
    'hide-button-animation': !_vm.showButtonAnimation
  },style:(_vm.styleProps),on:{"click":_vm.onClickButton}},[(_vm.titleProps)?_c('p',{staticClass:"averta-bold color-white"},[_vm._v(_vm._s(_vm.titleProps))]):_vm._e(),_c('div',{staticClass:"flex-center",style:(_vm.styleIconProps)},[_c('img',{style:({
        transform: _vm.isMobile ? 'scale(0.8)' : 'scale(1.3)'
      }),attrs:{"src":require('@/assets/img/arrow-upward.png'),"alt":""}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }